import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

const xsmallQuery = `@media (max-width: ${breakpoints.xsmall.max}px)`;

// `&&` outranks the design system's single-class modal styles regardless of stylesheet order.
export const signatureModalStyle = css({
  [xsmallQuery]: {
    '&&': { paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) },
  },
});

/** The design system stacks full-width actions on phones; keep them on one row to save vertical space. */
export const signatureModalFooterStyle = css({
  [xsmallQuery]: {
    '&&': {
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
      gridTemplateAreas: "'secondary primary'",
      gap: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
});

/** Centred in its container; capped at the pad's width so the Clear action lines up with it. */
export const drawAreaStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  alignSelf: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
});

export const drawAreaActionsStyle = css({
  display: 'flex',
  justifyContent: 'flex-end',
});

export const historyStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
});

export const historyListStyle = css({
  display: 'flex',
  gap: theme.spacing(1),
  overflowX: 'auto',
  paddingBottom: theme.spacing(0.5),
  margin: 0,
  listStyle: 'none',
  paddingLeft: 0,
});

export const historyItemStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 96,
  height: 56,
  padding: theme.spacing(1),
  backgroundColor: theme.colors.white,
  border: `1px solid ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.small,

  '&:hover, &:focus-visible': {
    borderColor: theme.colors.primary50,
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.6,
  },

  img: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
});
